"use client";

import classNames from "classnames";
import type { ReactNode } from "react";
import toast, { type Toast } from "react-hot-toast";
import styles from "./toast.module.scss";
import { motion } from "framer-motion";
import BlessButton from "@components/layout/button/green-outline-btn";
import Link from "next/link";
import { ToastIcon } from "@/components/layout/toast/icon-resolver";

export interface ToastContentType {
  message?: string | ReactNode;
  header?: string;
  status?: "success" | "error" | "info" | "warning";
}
export interface ToastButtonType {
  btnLink?: string;
  btnText?: string;
}

export interface CustomToastType {
  toastContent: ToastContentType;
  buttonContent?: ToastButtonType;
  toastData?: Toast;
}

const Toast = ({ toastContent, buttonContent, toastData }: CustomToastType) => {
  return (
    <motion.div
      initial={{ scale: 0.3 }}
      animate={{ scale: 1 }}
      className={classNames(styles.toast)}
    >
      <div className={styles.contentWrapper}>
        {/* Toast status indicator */}
        {toastContent.status && (
          <div
            className={classNames(
              styles.indicator,
              styles[toastContent.status],
            )}
          />
        )}

        {/* Toast content area */}
        <div className={styles.content}>
          {toastContent.header && (
            <div className={styles.headerArea}>
              <div className={styles.iconWrapper}>
                <ToastIcon icon={toastContent.status} />
              </div>
              <p className={styles.header}>{toastContent.header}</p>
            </div>
          )}
          {toastContent.message && (
            <div className={styles.messageBox}>{toastContent.message}</div>
          )}
          {/* Button link */}
          {buttonContent?.btnLink && (
            <div className={styles.buttonWrapper}>
              <Link href={buttonContent.btnLink} target="_blank">
                <BlessButton
                  size="small"
                  styles={{ width: "100%" }}
                  onClick={() => {
                    if (toastData?.id) {
                      toast.dismiss(toastData.id);
                    }
                  }}
                >
                  {buttonContent.btnText ? buttonContent.btnText : "View"}
                </BlessButton>
              </Link>
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default Toast;
